<div
  style="display: flex; flex-direction: column"
  [ngClass]="{ 'mermaid-wrapper': true, 'mermaid-fullscreen': fullScreen }"
  class="mermaid-wrapper mermaid-fullscreen"
>
  <div class="table-header visualizer-header">
    <div class="header">
      <svg-icon src="assets\images\svg\icon_visualizer.svg"></svg-icon> {{ 'VISUALIZER' | translate }}
    </div>
    <div class="action-icons d-flex">
      <img
        src="assets\images\icon_zoom_in.png"
        class="icon-style"
        alt="Zoom In"
        (click)="zoomIn()"
        (keyup.enter)="zoomIn()"
        tabindex="0"
        aria-label="Zoom In"
      />
      <img
        src="assets\images\icon_zoom_out.png"
        class="icon-style"
        alt="Zoom Out"
        (click)="zoomOut()"
        (keyup.enter)="zoomOut()"
        tabindex="1"
        aria-label="Zoom out"
      />
    </div>
  </div>
  <div class="mermaid-container">
    <div #mermaid id="sample" class="mermaid"></div>
    <div id="tooltip"></div>
  </div>
</div>
